module.exports = __webpack_public_path__ + "img/seniors.cecbfefa.svg";